
// 이미 접수된 데이터 삭제 요청 있음
export const ALREADY_REQUESTED = "alreadyClearJobRequested";

// 데이터 양이 많아 처리 job을 별도로 수행함
export const JOB_ACCEPTED = "clearJobAccepted";

// 데이터 삭제 완료
export const CLEAR_DONE = "clearDataDone";
